import React from 'react';
// import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
import shape from '../../images/testimonial-shape.png'
import {useTranslation} from "react-i18next";

const Testimonial = () => {

    const { t } = useTranslation();


    return (
        <section id='praxis' className="wpo-testimonial-section section-padding">
            <div className="testimonial-shape">
                <img src={shape} alt=""/>
            </div>
            <div className="row justify-content-center">
                <div className="col-lg-10">
                    <div className="wpo-section-title">
                        <span>{t('praxis_subtitle')}</span>
                        <h2 style={{ fontWeight: 'bold' }}>{t('praxis_title')}</h2>
                    </div>
                </div>
            </div>
            <div className="container">
                <div
                    style={{
                        margin: 'auto',
                        minHeight: '240px',
                        maxWidth: '960px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        border: '2px dashed #7f8c9a',
                        borderRadius: '16px',
                        background: '#f2f6f9',
                        color: '#1d4f91',
                        fontSize: 'clamp(24px, 4vw, 52px)',
                        fontWeight: 700,
                        textAlign: 'center',
                        padding: '48px 24px',
                    }}
                >
                    {t('praxis_coming_soon')}
                </div>
            </div>
        </section>
    );
}

export default Testimonial;